import { Option } from "@campgladiator/cgui-core.atoms.dropdown";
export const setInitialValueIfOnlyOneOption = (options: Option[]) =>
  options?.length === 1 ? [{ ...options[0], isDefault: true }] : options;
